import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom'
import { checkValidity } from '../../store/Utility';
import * as actions from '../../store/actions/index';

import Aux from '../../hoc/Auxiliary';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';

import classes from './SignUp.module.css';
//import { GOOGLE_API_KEY } from '../GoogleCalendar/config';


class Auth extends Component {
    state = {
        authForm: {
            email: {
                label: 'Email',
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                label: 'Password',
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        },
        idToken: ''
    }


    inputChangedHandler = (event, inputId) => {
        const updatedForm = { ...this.state.authForm };
        let updatedElement = { ...updatedForm[inputId] };
        updatedElement.value = event.target.value;
        updatedElement.valid = checkValidity(event.target.value, this.state.authForm[inputId].validation);
        updatedElement.touched = true;
        updatedForm[inputId] = updatedElement;
        this.setState({ authForm: updatedForm });
    }

    signInHandler = (event) => {
        event.preventDefault();
        this.props.signIn(this.state.authForm.email.value, this.state.authForm.password.value)
    }

    googleSignInHandler = (event) => {
        event.preventDefault();
        this.props.googleSignIn();
    }

    render() {
        const formElementArray = [];
        for (let key in this.state.authForm) {
            formElementArray.push({
                id: key,
                config: this.state.authForm[key]
            });
        }

        let form = (<Aux>
            {
                formElementArray.map(formElement => (
                    <Input
                        changed={(event) => this.inputChangedHandler(event, formElement.id)}
                        key={formElement.id}
                        elementId={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        label={formElement.config.label}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                    />
                ))
            }
        </Aux>);
        let authRedirect = null;
        if (this.props.currentUser !== null) {
            authRedirect = <Redirect to='/' />
        }
        return (
            < div className={classes.Box} >
                {authRedirect}
                < form className={classes.Form} >
                    {form}
                    < div className={classes.ButtonBox} >
                        <Button clicked={this.signInHandler}>SIGN IN</Button>
                        <Button clicked={this.googleSignInHandler}>Google Sign In</Button>
                        <Link to='/signup'><Button>SIGN UP</Button></Link>
                    </div >
                </form >
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const mapDispatchToProps = dispatch => {
    return {
        googleSignIn: () => dispatch(actions.googleSignIn()),
        signIn: (email, password) => dispatch(actions.signInFireBaseUser(email, password))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);